export default __webpack_public_path__ + "static/media/n1.b5733ebf.jpeg";